// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useExam } from "../context/ExamContext";

// import {
//   createPaymentOrder,
//   verifyPayment,
//   simulatePaymentSuccess,
// } from "../api/client";

// import AppSidebar from "../pages/AppSidebar";

// /* ==========================================================
//    RAZORPAY SCRIPT
//    ========================================================== */

// const RAZORPAY_SCRIPT =
//   "https://checkout.razorpay.com/v1/checkout.js";

// function loadRazorpayScript() {
//   return new Promise((resolve) => {
//     if (window.Razorpay) {
//       resolve(true);
//       return;
//     }

//     const existingScript =
//       document.querySelector(
//         `script[src="${RAZORPAY_SCRIPT}"]`
//       );

//     if (existingScript) {
//       existingScript.onload = () => resolve(true);
//       existingScript.onerror = () => resolve(false);
//       return;
//     }

//     const script =
//       document.createElement("script");

//     script.src = RAZORPAY_SCRIPT;
//     script.async = true;

//     script.onload = () => resolve(true);
//     script.onerror = () => resolve(false);

//     document.body.appendChild(script);
//   });
// }

// /* ==========================================================
//    PAYMENT PAGE
//    ========================================================== */

// export default function Payment() {
//   const navigate = useNavigate();

//   const {
//     currentUser,
//     selectedCourse,
//     selectedExam,
//     registrationId,
//     criteriaAccepted,
//     paymentStatus,
//     setPaymentStatus,
//   } = useExam();

//   const [processing, setProcessing] =
//     useState(false);

//   const [loadingGateway, setLoadingGateway] =
//     useState(true);

//   const [error, setError] =
//     useState("");

//   const [couponCode, setCouponCode] = useState("");

//   /* ========================================================
//      SELECTED EXAM
//      ======================================================== */

//   const exam =
//     selectedExam || selectedCourse;

//   /* ========================================================
//      PROTECTION
//      ======================================================== */

//   useEffect(() => {
//     if (!exam) {
//       navigate("/home", {
//         replace: true,
//       });

//       return;
//     }

//     if (!criteriaAccepted) {
//       navigate("/exam-criteria", {
//         replace: true,
//       });
//     }
//   }, [
//     exam,
//     criteriaAccepted,
//     navigate,
//   ]);

//   /* ========================================================
//      LOAD RAZORPAY
//      ======================================================== */

//   useEffect(() => {
//     let mounted = true;

//     loadRazorpayScript().then((loaded) => {
//       if (!mounted) {
//         return;
//       }

//       setLoadingGateway(!loaded);

//       if (!loaded) {
//         setError(
//           "Unable to load the Razorpay payment gateway. Please check your internet connection and try again."
//         );
//       }
//     });

//     return () => {
//       mounted = false;
//     };
//   }, []);

//   /* ========================================================
//      ALREADY PAID
//      ======================================================== */

//   useEffect(() => {
//     if (
//       paymentStatus === "SUCCESS" ||
//       paymentStatus === "Paid"
//     ) {
//       navigate("/schedule", {
//         replace: true,
//       });
//     }
//   }, [
//     paymentStatus,
//     navigate,
//   ]);

//   /* ========================================================
//      SAFETY
//      ======================================================== */

//   if (!exam) {
//     return null;
//   }

//   /* ========================================================
//      EXAM INFORMATION
//      ======================================================== */

//   const examFee =
//     Number(exam.fee || 0);

//   /* ========================================================
//      REAL RAZORPAY PAYMENT
//      ======================================================== */

//   const handlePayment = async () => {
//     if (!exam?.id) {
//       setError(
//         "Examination information is missing."
//       );

//       return;
//     }

//     if (!registrationId) {
//       setError(
//         "Examination registration is missing. Please return to the examination criteria page and continue again."
//       );

//       return;
//     }

//     if (examFee <= 0) {
//       setError(
//         "Invalid examination fee. Please contact the administrator."
//       );

//       return;
//     }

//     setProcessing(true);
//     setError("");

//     try {
//       /* ======================================================
//          STEP 1
//          CREATE RAZORPAY ORDER IN DJANGO
//          ====================================================== */

//       const orderResponse =
//         await createPaymentOrder(
//           exam.id,
//           couponCode
//         );

//       const orderData =
//         orderResponse.data;

//       /*
//        * If Django says payment is already
//        * completed, don't open Razorpay again.
//        */

//       if (
//         orderData?.already_paid === true ||
//         orderData?.status === "SUCCESS" ||
//         orderData?.payment_status ===
//           "SUCCESS"
//       ) {
//         setPaymentStatus("SUCCESS");

//         navigate("/schedule", {
//           replace: true,
//         });

//         return;
//       }

//       const orderId =
//         orderData?.order_id ||
//         orderData?.razorpay_order_id;

//       const amount =
//         orderData?.amount ||
//         Math.round(examFee * 100);

//       const currency =
//         orderData?.currency || "INR";

//       const razorpayKey =
//         orderData?.key_id ||
//         orderData?.razorpay_key_id ||
//         orderData?.public_key ||
//         process.env
//           .REACT_APP_RAZORPAY_KEY_ID;

//       if (!orderId) {
//         throw new Error(
//           "Razorpay order was not created by the Django backend."
//         );
//       }

//       if (!razorpayKey) {
//         throw new Error(
//           "Razorpay public key is missing."
//         );
//       }

//       if (!window.Razorpay) {
//         throw new Error(
//           "Razorpay checkout is not available."
//         );
//       }

//       /* ======================================================
//          STEP 2
//          OPEN RAZORPAY CHECKOUT
//          ====================================================== */

//       const options = {
//         key: razorpayKey,

//         amount: amount,

//         currency: currency,

//         name: "Online Examination System",

//         description:
//           exam.name ||
//           "Examination Fee",

//         order_id: orderId,

//         prefill: {
//           name:
//             currentUser?.full_name ||
//             currentUser?.fullName ||
//             "",

//           email:
//             currentUser?.email || "",
//         },

//         notes: {
//           exam_id: String(exam.id),

//           registration_id:
//             String(registrationId),
//         },

//         theme: {
//           color: "#0d6efd",
//         },

//         handler: async function (
//           razorpayResponse
//         ) {
//           try {
//             setProcessing(true);
//             setError("");

//             /* ================================================
//                STEP 3
//                VERIFY PAYMENT WITH DJANGO
//                ================================================ */

//             const verificationResponse =
//               await verifyPayment({
//                 examId: exam.id,

//                 razorpayOrderId:
//                   razorpayResponse.razorpay_order_id,

//                 razorpayPaymentId:
//                   razorpayResponse.razorpay_payment_id,

//                 razorpaySignature:
//                   razorpayResponse.razorpay_signature,
//               });

//             const verificationData =
//               verificationResponse.data;

//             /*
//              * Django has verified the Razorpay
//              * signature and should have marked:
//              *
//              * Payment = SUCCESS
//              * Registration = PAID
//              */

//             if (
//               verificationData?.status &&
//               verificationData.status !==
//                 "SUCCESS" &&
//               verificationData.status !==
//                 "PAID"
//             ) {
//               throw new Error(
//                 "Payment verification was not successful."
//               );
//             }

//             setPaymentStatus("SUCCESS");

//             navigate("/schedule", {
//               replace: true,
//             });
//           } catch (
//             verificationError
//           ) {
//             console.error(
//               "PAYMENT VERIFICATION ERROR:",
//               verificationError
//             );

//             const backendData =
//               verificationError?.response
//                 ?.data;

//             const message =
//               backendData?.detail ||
//               backendData?.message ||
//               verificationError?.message ||
//               "Payment was completed, but Django could not verify the payment.";

//             setError(message);

//             setProcessing(false);
//           }
//         },

//         modal: {
//           ondismiss: function () {
//             setProcessing(false);
//           },
//         },
//       };

//       /* ======================================================
//          STEP 4
//          OPEN CHECKOUT
//          ====================================================== */

//       const razorpay =
//         new window.Razorpay(options);

//       razorpay.on(
//         "payment.failed",
//         function (response) {
//           console.error(
//             "RAZORPAY PAYMENT FAILED:",
//             response
//           );

//           const reason =
//             response?.error
//               ?.description ||
//             "Payment failed. Please try again.";

//           setError(reason);

//           setProcessing(false);
//         }
//       );

//       razorpay.open();
//     } catch (paymentError) {
//       console.error(
//         "PAYMENT ERROR:",
//         paymentError
//       );

//       const backendData =
//         paymentError?.response?.data;

//       const message =
//         backendData?.detail ||
//         backendData?.message ||
//         paymentError?.message ||
//         "Unable to start the payment.";

//       setError(message);

//       setProcessing(false);
//     }
//   };

//   /* ========================================================
//      DEVELOPMENT TEST PAYMENT
//      ======================================================== */

//   const handleTestPayment = async () => {
//     if (!exam?.id) {
//       setError(
//         "Examination information is missing."
//       );

//       return;
//     }

//     if (!registrationId) {
//       setError(
//         "Examination registration is missing."
//       );

//       return;
//     }

//     setProcessing(true);
//     setError("");

//     try {
//       /*
//        * This calls the Django development-only
//        * test payment endpoint.
//        *
//        * It does NOT charge the student.
//        */

//       const response =
//         await simulatePaymentSuccess(
//           exam.id
//         );

//       const data =
//         response?.data;

//       if (
//         data?.status !== "SUCCESS"
//       ) {
//         throw new Error(
//           "Test payment was not completed."
//         );
//       }

//       /*
//        * Update React state.
//        */

//       setPaymentStatus("SUCCESS");

//       /*
//        * Continue exactly like a real
//        * successful payment.
//        */

//       navigate("/schedule", {
//         replace: true,
//       });
//     } catch (testPaymentError) {
//       console.error(
//         "TEST PAYMENT ERROR:",
//         testPaymentError
//       );

//       const backendData =
//         testPaymentError?.response?.data;

//       const message =
//         backendData?.detail ||
//         backendData?.message ||
//         testPaymentError?.message ||
//         "Test payment failed.";

//       setError(message);

//       setProcessing(false);
//     }
//   };

//   /* ========================================================
//      UI
//      ======================================================== */

//   return (
//     <div className="oes-page-full">

//       <div className="oes-home-shell d-flex flex-row overflow-hidden">

//         <AppSidebar />

//         <div className="flex-grow-1 oes-page container">

//           <div
//             className="row g-3 g-md-4 justify-content-center"
//             style={{
//               maxWidth: 760,
//               margin: "0 auto",
//             }}
//           >

//             {/* ==================================================
//                 SELECTED EXAM
//                 ================================================== */}

//             <div className="col-12 col-md-6">

//               <div className="oes-card p-3 p-md-4 h-100">

//                 <h2 className="h6 fw-bold mb-3">
//                   Selected Exam
//                 </h2>

//                 <table className="table table-borderless mb-0">

//                   <tbody>

//                     <tr>

//                       <td className="text-muted small">
//                         Course
//                       </td>

//                       <td className="fw-semibold">
//                         : {exam.name}
//                       </td>

//                     </tr>

//                     <tr>

//                       <td className="text-muted small">
//                         Exam Fee
//                       </td>

//                       <td className="fw-semibold">
//                         : ₹
//                         {examFee.toLocaleString(
//                           "en-IN"
//                         )}
//                       </td>

//                     </tr>

//                     <tr>

//                       <td className="text-muted small">
//                         Payment Status
//                       </td>

//                       <td
//                         className={`fw-semibold ${
//                           paymentStatus ===
//                             "SUCCESS" ||
//                           paymentStatus ===
//                             "Paid"
//                             ? "text-success"
//                             : "text-danger"
//                         }`}
//                       >
//                         :{" "}
//                         {paymentStatus ===
//                             "SUCCESS" ||
//                         paymentStatus ===
//                           "Paid"
//                           ? "Paid"
//                           : "Pending"}
//                       </td>

//                     </tr>

//                   </tbody>

//                 </table>

//               </div>

//             </div>

//             {/* ==================================================
//                 PAYMENT
//                 ================================================== */}

//             <div className="col-12 col-md-6">

//               <div className="oes-card p-3 p-md-4 h-100 d-flex flex-column">

//                 <h2 className="h6 fw-bold mb-3">
//                   Secure Payment
//                 </h2>

//                 {/* PAYMENT ICON */}

//                 <div className="text-center mb-3">

//                   <div
//                     className="rounded-circle bg-primary bg-opacity-10 d-inline-flex align-items-center justify-content-center"
//                     style={{
//                       width: 80,
//                       height: 80,
//                     }}
//                   >

//                     <i className="bi bi-credit-card fs-2 text-primary" />

//                   </div>

//                 </div>

//                 {/* AMOUNT */}

//                 <div className="text-center mb-3">

//                   <div className="fw-bold fs-5">
//                     ₹
//                     {examFee.toLocaleString(
//                       "en-IN"
//                     )}
//                   </div>

//                   <div className="small text-muted">
//                     Examination registration fee
//                   </div>

//                 </div>

//                 {/* ERROR */}

//                 {error && (
//                   <div
//                     className="alert alert-danger small text-start w-100 mb-3 py-2"
//                     role="alert"
//                   >
//                     {error}
//                   </div>
//                 )}

//                 <div className="coupon-entry text-start w-100 mb-3">
//                   <label className="form-label" htmlFor="exam-coupon-code">Coupon code</label>
//                   <input id="exam-coupon-code" className="form-control" value={couponCode} onChange={(event) => setCouponCode(event.target.value.toUpperCase())} placeholder="Enter coupon code" autoComplete="off" />
//                   <small className="text-muted">The server validates the coupon before creating your payment order.</small>
//                 </div>

//                 {/* REAL RAZORPAY PAYMENT */}

//                 <button
//                   type="button"
//                   className="btn btn-primary w-100 mt-auto"
//                   onClick={handlePayment}
//                   disabled={
//                     processing ||
//                     loadingGateway ||
//                     !registrationId
//                   }
//                 >
//                   {processing
//                     ? "Processing..."
//                     : loadingGateway
//                     ? "Loading payment..."
//                     : "PAY ₹" +
//                       examFee.toLocaleString(
//                         "en-IN"
//                       )}
//                 </button>

//                 {/* ==================================================
//                     DEVELOPMENT TEST PAYMENT
//                     ================================================== */}

//                 {process.env.NODE_ENV ===
//                   "development" && (
//                   <div className="mt-2">

//                     <button
//                       type="button"
//                       className="btn btn-outline-warning w-100"
//                       onClick={
//                         handleTestPayment
//                       }
//                       disabled={
//                         processing ||
//                         !registrationId
//                       }
//                     >
//                       {processing
//                         ? "Processing..."
//                         : "TEST: Simulate Successful Payment"}
//                     </button>

//                     <div className="text-muted text-center mt-1">
//                       <small>
//                         Development testing only.
//                         No real payment will be charged.
//                       </small>
//                     </div>

//                   </div>
//                 )}

//                 {/* SECURE PAYMENT MESSAGE */}

//                 <div className="d-flex align-items-center gap-2 text-start bg-success bg-opacity-10 rounded-3 p-2 mt-3 w-100">

//                   <span
//                     className="d-inline-flex align-items-center justify-content-center rounded-circle bg-success text-white flex-shrink-0"
//                     style={{
//                       width: 28,
//                       height: 28,
//                     }}
//                   >

//                     <i
//                       className="bi bi-shield-lock-fill"
//                       style={{
//                         fontSize: "0.8rem",
//                       }}
//                     />

//                   </span>

//                   <div>

//                     <div className="small fw-bold text-success lh-1 mb-1">
//                       Secure Payment
//                     </div>

//                     <div className="small text-muted lh-1">
//                       Payment is securely processed
//                       through Razorpay.
//                     </div>

//                   </div>

//                 </div>

//               </div>

//             </div>

//           </div>

//         </div>

//       </div>

//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useExam } from "../context/ExamContext";

import {
  createPaymentOrder,
  verifyPayment,
  simulatePaymentSuccess,
} from "../api/client";

import AppSidebar from "../pages/AppSidebar";

/* ==========================================================
   RAZORPAY SCRIPT
   ========================================================== */

const RAZORPAY_SCRIPT =
  "https://checkout.razorpay.com/v1/checkout.js";

function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }

    const existingScript =
      document.querySelector(
        `script[src="${RAZORPAY_SCRIPT}"]`
      );

    if (existingScript) {
      existingScript.onload = () => resolve(true);
      existingScript.onerror = () => resolve(false);
      return;
    }

    const script =
      document.createElement("script");

    script.src = RAZORPAY_SCRIPT;
    script.async = true;

    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);

    document.body.appendChild(script);
  });
}

/* ==========================================================
   PAYMENT PAGE
   ========================================================== */

export default function Payment() {
  const navigate = useNavigate();

  const {
    currentUser,
    selectedCourse,
    selectedExam,
    registrationId,
    criteriaAccepted,
    paymentStatus,
    setPaymentStatus,
  } = useExam();

  const [processing, setProcessing] =
    useState(false);

  const [loadingGateway, setLoadingGateway] =
    useState(true);

  const [error, setError] =
    useState("");

  const [couponCode, setCouponCode] = useState("");

  /* ========================================================
     SELECTED EXAM
     ======================================================== */

  const exam =
    selectedExam || selectedCourse;

  /* ========================================================
     PROTECTION
     ======================================================== */

  useEffect(() => {
    if (!exam) {
      navigate("/home", {
        replace: true,
      });

      return;
    }

    if (!criteriaAccepted) {
      navigate("/exam-criteria", {
        replace: true,
      });
    }
  }, [
    exam,
    criteriaAccepted,
    navigate,
  ]);

  /* ========================================================
     LOAD RAZORPAY
     ======================================================== */

  useEffect(() => {
    let mounted = true;

    loadRazorpayScript().then((loaded) => {
      if (!mounted) {
        return;
      }

      setLoadingGateway(!loaded);

      if (!loaded) {
        setError(
          "Unable to load the Razorpay payment gateway. Please check your internet connection and try again."
        );
      }
    });

    return () => {
      mounted = false;
    };
  }, []);

  /* ========================================================
     ALREADY PAID
     ======================================================== */

  useEffect(() => {
    if (
      paymentStatus === "SUCCESS" ||
      paymentStatus === "Paid"
    ) {
      navigate("/schedule", {
        replace: true,
      });
    }
  }, [
    paymentStatus,
    navigate,
  ]);

  /* ========================================================
     SAFETY
     ======================================================== */

  if (!exam) {
    return null;
  }

  /* ========================================================
     EXAM INFORMATION
     ======================================================== */

  const examFee =
    Number(exam.fee || 0);

  /* ========================================================
     REAL RAZORPAY PAYMENT
     ======================================================== */

  const handlePayment = async () => {
    if (!exam?.id) {
      setError(
        "Examination information is missing."
      );

      return;
    }

    if (!registrationId) {
      setError(
        "Examination registration is missing. Please return to the examination criteria page and continue again."
      );

      return;
    }

    if (examFee <= 0) {
      setError(
        "Invalid examination fee. Please contact the administrator."
      );

      return;
    }

    setProcessing(true);
    setError("");

    try {
      /* ======================================================
         STEP 1
         CREATE RAZORPAY ORDER IN DJANGO
         ====================================================== */

      const orderResponse =
        await createPaymentOrder(
          exam.id,
          couponCode
        );

      const orderData =
        orderResponse.data;

      /*
       * If Django says payment is already
       * completed, don't open Razorpay again.
       */

      if (
        orderData?.already_paid === true ||
        orderData?.status === "SUCCESS" ||
        orderData?.payment_status ===
          "SUCCESS"
      ) {
        setPaymentStatus("SUCCESS");

        navigate("/schedule", {
          replace: true,
        });

        return;
      }

      const orderId =
        orderData?.order_id ||
        orderData?.razorpay_order_id;

      // Django returns amount_in_paise from the server-created order.
      // Razorpay Checkout expects paise, not rupees. Never derive this from
      // the displayed exam fee because coupons may change the payable amount.
      const amount = Number(orderData?.amount_in_paise);

      if (!Number.isSafeInteger(amount) || amount <= 0) {
        throw new Error(
          "The server returned an invalid payment amount. Please try again or contact support."
        );
      }

      const currency = orderData?.currency || "INR";

      const razorpayKey =
        orderData?.key_id ||
        orderData?.razorpay_key_id ||
        orderData?.public_key ||
        process.env
          .REACT_APP_RAZORPAY_KEY_ID;

      if (!orderId) {
        throw new Error(
          "Razorpay order was not created by the Django backend."
        );
      }

      if (!razorpayKey) {
        throw new Error(
          "Razorpay public key is missing."
        );
      }

      if (!window.Razorpay) {
        throw new Error(
          "Razorpay checkout is not available."
        );
      }

      /* ======================================================
         STEP 2
         OPEN RAZORPAY CHECKOUT
         ====================================================== */

      const options = {
        key: razorpayKey,

        amount: amount,

        currency: currency,

        name: "Online Examination System",

        description:
          exam.name ||
          "Examination Fee",

        order_id: orderId,

        prefill: {
          name:
            currentUser?.full_name ||
            currentUser?.fullName ||
            "",

          email:
            currentUser?.email || "",
        },

        notes: {
          exam_id: String(exam.id),

          registration_id:
            String(registrationId),
        },

        theme: {
          color: "#0d6efd",
        },

        handler: async function (
          razorpayResponse
        ) {
          try {
            setProcessing(true);
            setError("");

            /* ================================================
               STEP 3
               VERIFY PAYMENT WITH DJANGO
               ================================================ */

            const verificationResponse =
              await verifyPayment({
                examId: exam.id,

                razorpayOrderId:
                  razorpayResponse.razorpay_order_id,

                razorpayPaymentId:
                  razorpayResponse.razorpay_payment_id,

                razorpaySignature:
                  razorpayResponse.razorpay_signature,
              });

            const verificationData =
              verificationResponse.data;

            /*
             * Django has verified the Razorpay
             * signature and should have marked:
             *
             * Payment = SUCCESS
             * Registration = PAID
             */

            const verifiedStatus = String(
              verificationData?.status || ""
            ).toUpperCase();

            if (!["SUCCESS", "PAID"].includes(verifiedStatus)) {
              throw new Error(
                "Payment verification was not confirmed by the server. Please do not retry payment immediately; check your payment history or contact support."
              );
            }

            setPaymentStatus("SUCCESS");

            navigate("/schedule", {
              replace: true,
            });
          } catch (
            verificationError
          ) {
            console.error(
              "PAYMENT VERIFICATION ERROR:",
              verificationError
            );

            const backendData =
              verificationError?.response
                ?.data;

            const message =
              backendData?.detail ||
              backendData?.message ||
              verificationError?.message ||
              "Payment was completed, but Django could not verify the payment.";

            setError(message);

            setProcessing(false);
          }
        },

        modal: {
          ondismiss: function () {
            setProcessing(false);
          },
        },
      };

      /* ======================================================
         STEP 4
         OPEN CHECKOUT
         ====================================================== */

      const razorpay =
        new window.Razorpay(options);

      razorpay.on(
        "payment.failed",
        function (response) {
          console.error(
            "RAZORPAY PAYMENT FAILED:",
            response
          );

          const reason =
            response?.error
              ?.description ||
            "Payment failed. Please try again.";

          setError(reason);

          setProcessing(false);
        }
      );

      razorpay.open();
    } catch (paymentError) {
      console.error(
        "PAYMENT ERROR:",
        paymentError
      );

      const backendData =
        paymentError?.response?.data;

      const message =
        backendData?.detail ||
        backendData?.message ||
        paymentError?.message ||
        "Unable to start the payment.";

      setError(message);

      setProcessing(false);
    }
  };

  /* ========================================================
     DEVELOPMENT TEST PAYMENT
     ======================================================== */

  const handleTestPayment = async () => {
    if (!exam?.id) {
      setError(
        "Examination information is missing."
      );

      return;
    }

    if (!registrationId) {
      setError(
        "Examination registration is missing."
      );

      return;
    }

    setProcessing(true);
    setError("");

    try {
      /*
       * This calls the Django development-only
       * test payment endpoint.
       *
       * It does NOT charge the student.
       */

      const response =
        await simulatePaymentSuccess(
          exam.id
        );

      const data =
        response?.data;

      if (
        data?.status !== "SUCCESS"
      ) {
        throw new Error(
          "Test payment was not completed."
        );
      }

      /*
       * Update React state.
       */

      setPaymentStatus("SUCCESS");

      /*
       * Continue exactly like a real
       * successful payment.
       */

      navigate("/schedule", {
        replace: true,
      });
    } catch (testPaymentError) {
      console.error(
        "TEST PAYMENT ERROR:",
        testPaymentError
      );

      const backendData =
        testPaymentError?.response?.data;

      const message =
        backendData?.detail ||
        backendData?.message ||
        testPaymentError?.message ||
        "Test payment failed.";

      setError(message);

      setProcessing(false);
    }
  };

  /* ========================================================
     UI
     ======================================================== */

  return (
    <div className="oes-page-full">

      <div className="oes-home-shell d-flex flex-row overflow-hidden">

        <AppSidebar />

        <div className="flex-grow-1 oes-page container">

          <div
            className="row g-3 g-md-4 justify-content-center"
            style={{
              maxWidth: 760,
              margin: "0 auto",
            }}
          >

            {/* ==================================================
                SELECTED EXAM
                ================================================== */}

            <div className="col-12 col-md-6">

              <div className="oes-card p-3 p-md-4 h-100">

                <h2 className="h6 fw-bold mb-3">
                  Selected Exam
                </h2>

                <table className="table table-borderless mb-0">

                  <tbody>

                    <tr>

                      <td className="text-muted small">
                        Course
                      </td>

                      <td className="fw-semibold">
                        : {exam.name}
                      </td>

                    </tr>

                    <tr>

                      <td className="text-muted small">
                        Exam Fee
                      </td>

                      <td className="fw-semibold">
                        : ₹
                        {examFee.toLocaleString(
                          "en-IN"
                        )}
                      </td>

                    </tr>

                    <tr>

                      <td className="text-muted small">
                        Payment Status
                      </td>

                      <td
                        className={`fw-semibold ${
                          paymentStatus ===
                            "SUCCESS" ||
                          paymentStatus ===
                            "Paid"
                            ? "text-success"
                            : "text-danger"
                        }`}
                      >
                        :{" "}
                        {paymentStatus ===
                            "SUCCESS" ||
                        paymentStatus ===
                          "Paid"
                          ? "Paid"
                          : "Pending"}
                      </td>

                    </tr>

                  </tbody>

                </table>

              </div>

            </div>

            {/* ==================================================
                PAYMENT
                ================================================== */}

            <div className="col-12 col-md-6">

              <div className="oes-card p-3 p-md-4 h-100 d-flex flex-column">

                <h2 className="h6 fw-bold mb-3">
                  Secure Payment
                </h2>

                {/* PAYMENT ICON */}

                <div className="text-center mb-3">

                  <div
                    className="rounded-circle bg-primary bg-opacity-10 d-inline-flex align-items-center justify-content-center"
                    style={{
                      width: 80,
                      height: 80,
                    }}
                  >

                    <i className="bi bi-credit-card fs-2 text-primary" />

                  </div>

                </div>

                {/* AMOUNT */}

                <div className="text-center mb-3">

                  <div className="fw-bold fs-5">
                    ₹
                    {examFee.toLocaleString(
                      "en-IN"
                    )}
                  </div>

                  <div className="small text-muted">
                    Examination registration fee
                  </div>

                </div>

                {/* ERROR */}

                {error && (
                  <div
                    className="alert alert-danger small text-start w-100 mb-3 py-2"
                    role="alert"
                  >
                    {error}
                  </div>
                )}

                <div className="coupon-entry text-start w-100 mb-3">
                  <label className="form-label" htmlFor="exam-coupon-code">Coupon code</label>
                  <input id="exam-coupon-code" className="form-control" value={couponCode} onChange={(event) => setCouponCode(event.target.value.toUpperCase())} placeholder="Enter coupon code" autoComplete="off" />
                  <small className="text-muted">The server validates the coupon before creating your payment order.</small>
                </div>

                {/* REAL RAZORPAY PAYMENT */}

                <button
                  type="button"
                  className="btn btn-primary w-100 mt-auto"
                  onClick={handlePayment}
                  disabled={
                    processing ||
                    loadingGateway ||
                    !registrationId
                  }
                >
                  {processing
                    ? "Processing..."
                    : loadingGateway
                    ? "Loading payment..."
                    : "PAY ₹" +
                      examFee.toLocaleString(
                        "en-IN"
                      )}
                </button>

                {/* ==================================================
                    DEVELOPMENT TEST PAYMENT
                    ================================================== */}

                {process.env.NODE_ENV ===
                  "development" && (
                  <div className="mt-2">

                    <button
                      type="button"
                      className="btn btn-outline-warning w-100"
                      onClick={
                        handleTestPayment
                      }
                      disabled={
                        processing ||
                        !registrationId
                      }
                    >
                      {processing
                        ? "Processing..."
                        : "TEST: Simulate Successful Payment"}
                    </button>

                    <div className="text-muted text-center mt-1">
                      <small>
                        Development testing only.
                        No real payment will be charged.
                      </small>
                    </div>

                  </div>
                )}

                {/* SECURE PAYMENT MESSAGE */}

                <div className="d-flex align-items-center gap-2 text-start bg-success bg-opacity-10 rounded-3 p-2 mt-3 w-100">

                  <span
                    className="d-inline-flex align-items-center justify-content-center rounded-circle bg-success text-white flex-shrink-0"
                    style={{
                      width: 28,
                      height: 28,
                    }}
                  >

                    <i
                      className="bi bi-shield-lock-fill"
                      style={{
                        fontSize: "0.8rem",
                      }}
                    />

                  </span>

                  <div>

                    <div className="small fw-bold text-success lh-1 mb-1">
                      Secure Payment
                    </div>

                    <div className="small text-muted lh-1">
                      Payment is securely processed
                      through Razorpay.
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}